import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';
import $ from 'jquery';

import mask from 'jquery-mask-plugin';

// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
import '../css/fontawesome/css/all.min.css';
import '../css/fontes.css';
import '../css/margens.css';



// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';
import CryptoJS from '../js/jquery.md5.js';

Framework7.use(CryptoJS);


// Import main app component
import App from '../app.f7.html';

var app = new Framework7({
  root: '#app', // App root element
  component: App, // App main component
  id: 'br.com.mobwe.expositorbc', // App bundle ID
  name: 'Expositor', // App name
  theme: 'aurora', // Automatic theme detection
  data: function () {
    return {
      versao: "1.0.0",
      db: window.localStorage,
      baseUrl: baseUrl,
     

    };
  },
  smartSelect: {
    pageTitle: 'Selecione',
    openIn: 'popup',
  }, 

   methods: {
    ativarMascaras: function () {
        var options = {
          onKeyPress : function(cpfcnpj, e, field, options) {
            var masks = ['000.000.000-000', '00.000.000/0000-00'];
            var mask = (cpfcnpj.length > 14) ? masks[1] : masks[0];
            $('.cpfcnpj').mask(mask, options);
          }
        };

        $('input.cartao').mask('0000 0000 0000 0000');
        $('input.validade').mask('00/00');
        $('input.cpfcnpj').mask('000.000.000-000', options);
        $('input.cpf').mask('000.000.000-00', {reverse: false});
        $('input.cnpj').mask('00.000.000/0000-00', {reverse: false});      
        $("input.telefone").mask("(00) 00000-0000");
        $("input.celular").mask("(00) 00000-0000");
        $("input.cpf").mask("000.000.000-00");
        $("input.codigo").mask("SSSS-0000");
        $("input.codigovip").mask("SSS-0000");
        $("input.data").mask("00/00/0000");
        $('input.moeda').mask("#.##0,00", {reverse: true});
        $('input.inteiro').mask("#", {reverse: true});
    },      
    request: function(e) {
      var url = baseUrl + e +"?token="+window.localStorage.getItem("br.com.mobwe.expositorbc.token")
      return url;
    },
    autenticar: function() {
      var usuario = $$('#Usuario_email').val();
      app.preloader.show();
        app.request({
            url: baseUrl + '/autenticar',
            dataType: 'json',
            method: 'POST',
            data: {"codigo_acesso":usuario},
            cache: false,
            crossDomain: true,
            success: function (data) {
              app.preloader.hide();
              if(data.success == true) {
                
                app.data.db.setItem(app.id+".expositor", JSON.stringify(data.expositor));
                app.data.db.setItem(app.id+".token", data.token);
                app.preloader.hide();
                app.views.main.router.navigate('/inicial/', {reloadCurrent: true,ignoreCache: true});
                app.loginScreen.close('#my-login-screen'); 
              }
              else {
                var notification = app.notification.create({
                    icon: '<i class="fas fa-exclamation-triangle"></i>',
                    title: 'Atenção',
                    text: data.erro,
                    closeTimeout: 3000,
                    on: {
                      opened: function () {
                        
                      }
                    }
                  })
                notification.open()
                }
                
            }
        });

    },
    validarCodigo:function(codigo,direcao) {
      app.views.main.router.navigate('/codigo/'+codigo+"/", {reloadCurrent: true,ignoreCache: true});
                
    },
  },


  // App routes
  routes: routes,


  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  on: {
    init: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7,app);
        
      }
    },
  },
});



$$('body').on('click','.btnAutenticar', function () {
  app.methods.autenticar();
});

$$('body').on('click','.btnValidarIngresso', function () {
  var codigo = $$("#codigoDigitado").val();
  var direcao = $$('input[name=direcao]:checked').val();
  if(codigo != null && codigo != undefined && codigo != "")
    app.methods.validarCodigo(codigo,direcao);
});

/* ===== Leitor de QR Code — híbrido Cordova + Web (html5-qrcode) =====
   Cordova: usa cordova-plugin-barcodescanner nativo.
   Web (browser): abre popup com <div id="reader"> e usa a lib global Html5Qrcode
   carregada via <script src="https://unpkg.com/html5-qrcode"> no index.html. */

var html5QrCode = null;
var leitorQrAtivo = false;

function notificarErroQr(mensagem) {
  var notificationFull = appSel.notification.create({
    icon: '<i class="fas fa-exclamation-triangle"></i>',
    title: 'ERRO AO LER O CÓDIGO',
    text: mensagem,
    closeTimeout: 5000,
  });
  notificationFull.open();
}

function pararLeitorQrWeb() {
  return new Promise(function (resolve) {
    if (html5QrCode && leitorQrAtivo) {
      html5QrCode.stop()
        .then(function () {
          leitorQrAtivo = false;
          html5QrCode.clear();
          resolve();
        })
        .catch(function () {
          leitorQrAtivo = false;
          resolve();
        });
    } else {
      resolve();
    }
  });
}

function iniciarLeitorQrWeb() {
  $("#reader-status").html("Solicitando acesso à câmera...");

  if (!html5QrCode) {
    html5QrCode = new Html5Qrcode("reader");
  }

  Html5Qrcode.getCameras().then(function (devices) {
    if (!devices || !devices.length) {
      notificarErroQr("Nenhuma câmera encontrada.");
      return;
    }

    var cameraId = devices[0].id;
    for (var i = 0; i < devices.length; i++) {
      var label = (devices[i].label || "").toLowerCase();
      if (
        label.indexOf("back") !== -1 ||
        label.indexOf("rear") !== -1 ||
        label.indexOf("traseira") !== -1 ||
        label.indexOf("environment") !== -1
      ) {
        cameraId = devices[i].id;
        break;
      }
    }

    html5QrCode.start(
      cameraId,
      { fps: 10, qrbox: { width: 250, height: 250 }, aspectRatio: 1.0, disableFlip: false },
      function (decodedText) {
        if (!decodedText || decodedText == "") return;
        pararLeitorQrWeb().then(function () {
          app.popup.close('.popup-leitor-qrcode');
          try {
            var dados = $.parseJSON(decodedText);
            if (
              dados.ingresso != undefined &&
              dados.ingresso != "" &&
              dados.ingresso != null &&
              dados.ingresso != "null"
            ) {
              app.views.main.router.navigate('/codigo/' + dados.ingresso + '/', {
                reloadCurrent: false, ignoreCache: true
              });
            } else {
              notificarErroQr("QR Code lido, mas o campo ingresso não foi encontrado.");
            }
          } catch (e) {
            notificarErroQr("O conteúdo do QR Code não está em JSON válido.");
          }
        });
      },
      function () { /* erro de frame — ignora pra não poluir */ }
    ).then(function () {
      leitorQrAtivo = true;
      $("#reader-status").html("Posicione o QRCode na área.");
    }).catch(function (err) {
      notificarErroQr("Não foi possível iniciar a câmera: " + err);
    });

  }).catch(function (err) {
    notificarErroQr("Erro ao acessar a câmera: " + err);
  });
}

$$("body").on('click', '.btnLerCodigo', function () {
  if (window.cordova && window.cordova.plugins && window.cordova.plugins.barcodeScanner) {
    cordova.plugins.barcodeScanner.scan(
      function (result) {
        try {
          var dados = $.parseJSON(result.text);
          if (dados.ingresso != undefined && dados.ingresso != "" && dados.ingresso != null && dados.ingresso != "null") {
            app.views.main.router.navigate('/codigo/' + dados.ingresso + '/', { reloadCurrent: false, ignoreCache: true });
          }
        } catch (e) {
          notificarErroQr("O conteúdo do QR Code não está em JSON válido.");
        }
      },
      function (error) { notificarErroQr(error); },
      {
        preferFrontCamera: false,
        showFlipCameraButton: true,
        showTorchButton: true,
        torchOn: false,
        saveHistory: true,
        prompt: "Posicione o QRCode na Área",
        resultDisplayDuration: 500,
        formats: "QR_CODE",
        orientation: "portrait",
        disableAnimations: true,
        disableSuccessBeep: false
      }
    );
  } else {
    app.popup.open('.popup-leitor-qrcode');
    setTimeout(iniciarLeitorQrWeb, 300);
  }
});

$$("body").on('click', '.btnFecharLeitorQr', function () {
  pararLeitorQrWeb();
});

$$(document).on('popup:closed', '.popup-leitor-qrcode', function () {
  pararLeitorQrWeb();
});

export default app;